<template>
	<div class="review-box">
		<div class="widget widget-tags">
			<ul>
				<li>
					<a :class="type==0?'active':''" class="wid-link" @click='changeType(0)'>正式考试</a>
				</li>
				<li>
					<a :class="type==1?'active':''" class="wid-link" @click='changeType(1)'>模拟考试</a>
				</li>
			</ul>
		</div>
		<el-empty v-if="dataList.length==0" description="暂无数据"></el-empty>
		<b-row>
			<b-col sm="6" v-for="(item,index) in dataList" :key="index">
				<div style="margin-bottom: 20px;">
					<el-card class="box-card">
						<div class="retake" v-if="item.hasRetake">补考</div>
						<div slot="header" class="clearfix">
							<div v-if="type==0">
								<el-tag size="mini" v-if="item.hasPass" type="success">已及格</el-tag>
								<el-tag size="mini" v-else type="danger">不及格</el-tag>
							</div>
							<span style="margin-left: 8px;">{{item.paperName}}</span>
						</div>
						<div>
							<div v-if="type==0">分数：<span :style="item.hasPass?'color:green':'color:red'">{{item.score}}</span></div>
							<div class="bottom-clearfix">
								<div class="time">考试时间：{{item.createTime}}</div>
								<el-button @click="showPaper(item)" style="float: right; padding: 3px 0"
									type="text">查看详情</el-button>
							</div>
						</div>
					</el-card>
				</div>
				<!-- <div class="single-item">
					<div class="review-man">
						<img v-if="item.hasPass" src="@/assets/images/pass.png" alt="review-man">
						<img v-else src="@/assets/images/fail.png" alt="review-man">
					</div>
					<div class="content">
						<div class="name-other">
							<h6 class="headsix">{{item.paperName}}</h6>
						</div>
						<div style="display: flex;">
							<div class="text">分数：{{item.score}}分</div>
							<div style="margin-left: 25px;" class="text">用时：{{item.durationName}}</div>
						</div>
						<p style="margin-top: 6px;" class="text">考试时间：{{item.createTime}}</p>
					</div>
				</div> -->
			</b-col>
		</b-row>
		<div v-if="total>0" class="row">
			<div class="col-lg-12  wow fadeInUp">
				<div style="text-align: center;">
					<el-pagination background @current-change="getList" :current-page.sync="queryParams.pageNum"
						:page-size="queryParams.pageSize" layout="total, prev, pager, next" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<b-modal ref="my-modal" :title="chooseInfo.paperName" size="lg">
			<div class="paper-area">
				<div class="pop-top">
					<img class="pass" v-if="chooseInfo.hasPass" src="@/assets/images/pass.png" alt="review-man">
					<img class="pass" v-else src="@/assets/images/fail.png" alt="review-man">
					<div style="margin-left: 20px;">
						<div v-if="type==0">分数：
							<span :style="chooseInfo.hasPass?'color:green':'color:red'"
								class="score">{{chooseInfo.score}}分</span>
						</div>
						<div>用时：<span class="score">{{chooseInfo.durationName}}</span></div>
					</div>
				</div>
				<div class="paper-split"></div>
				<div v-for="(item,index) in paperSubjects" :key="index" class="question-area">
					<div class="subject-name">{{ index + 1 }}.
						<span v-if="item.type==0">【单选题】</span>
						<span v-if="item.type==1">【多选题】</span>
						{{ item.subjectName }}<span v-if="type==0">({{item.subjectScore}}分)</span>
					</div>
					<div v-if="item.type==0">
						<div v-for="(item1,index1) in item.paperSubjectOptions" :key="index1">
							{{ String.fromCharCode('A'.charCodeAt(0) + index1) + '.   ' + item1.optionName }}
						</div>
						<!-- <el-radio-group disabled v-model="radio">
							<el-radio style="display:block;margin-bottom: 10px;"
								v-for="(item1,index1) in item.paperSubjectOptions" :key="index1"
								:label="item1.hasSelectThisOption">
								{{ String.fromCharCode('A'.charCodeAt(0) + index1) + '.   ' + item1.optionName }}
							</el-radio>
						</el-radio-group> -->
						<div style="display: flex;align-items: center;margin: 6px 0;">
							<div>我的答案：<span
									style="font-family: Arial,sans-serif;color: blue;font-weight: bold;">{{String.fromCharCode('A'.charCodeAt(0) + item.commitAnswer)}}</span>
							</div>
							<div style="margin-left: 20px;font-weight: 700;font-size: 22px;">
								<i style="color: limegreen;" v-if="item.trueOrFalse" class="el-icon-check"></i>
								<i style="color: red;" v-else class="el-icon-close"></i>
							</div>
						</div>
						<div style="color: red;">正确答案：{{String.fromCharCode('A'.charCodeAt(0) + item.rightAnswer)}}
						</div>
						<div style="color: seagreen;margin-top: 10px;" v-if="item.analyzes">解析：{{item.analyzes}}</div>
					</div>
					<div v-if="item.type==1">
						<div v-for="(item1,index1) in item.paperSubjectOptions" :key="index1">
							{{String.fromCharCode('A'.charCodeAt(0) + index1)+'.   '+item1.optionName}}
						</div>
						<!-- <el-checkbox disabled v-model="item1.hasSelectThisOption"
							style="display:block;margin-bottom: 10px;"
							v-for="(item1,index1) in item.paperSubjectOptions"
							:key="index1">{{String.fromCharCode('A'.charCodeAt(0) + index1)+'.   '+item1.optionName}}</el-checkbox>
						 -->
						<div style="display: flex;align-items: center;margin: 6px 0;">
							<div>我的答案：
								<span style="font-family: Arial,sans-serif;color: blue;font-weight: bold;"
									v-for="(answer,i) in item.paperSubjectOptions"
									:key="i">{{answer.hasSelectThisOption?String.fromCharCode('A'.charCodeAt(0) + i):''}}</span>
							</div>
							<div style="margin-left: 20px;font-weight: 700;font-size: 22px;">
								<i style="color: limegreen;" v-if="item.trueOrFalse" class="el-icon-check"></i>
								<i style="color: red;" v-else class="el-icon-close"></i>
							</div>
						</div>
						<div style="color: red;">正确答案：<span v-for="(answer,i) in item.paperSubjectOptions"
								:key="i">{{answer.trueOrFalse?String.fromCharCode('A'.charCodeAt(0) + i):''}}</span>
						</div>
						<div style="color: seagreen;margin-top: 10px;" v-if="item.analyzes">解析：{{item.analyzes}}</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<!--            <el-button type="primary" @click="submitForm">提交</el-button>-->
				</div>
			</div>
			<template v-slot:modal-footer="{ ok, cancel, hide }">
				<b-button variant="success" @click="cancel()">
					确定
				</b-button>
				<b-button variant="danger" @click="cancel()">
					取消
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
	import {
		myExam,
		answerPaperEcho
	} from "@/api/userCenter";
	import {
		genPaperByPaperId
	} from "@/api/lesson";
	export default {
		data() {
			return {
				queryParams: {
					pageNum: 1,
					pageSize: 10
				},
				radio: true,
				total: 0,
				type: 0,
				dataList: [],
				chooseInfo: {},
				paperSubjects: [], //试卷信息
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			changeType(index) {
				this.type = index
				this.getList()
			},
			getList() {
				myExam(this.queryParams, this.type).then(res => {
					this.dataList = res.rows
					this.total = res.total;
				})
			},
			//试卷回显
			showPaper(item) {
				answerPaperEcho(item.baseId).then(res => {
					this.chooseInfo = res.data
					this.paperSubjects = res.data.paperInfo.paperSubjects
					this.paperSubjects.map((item, index) => {
						if (item.type == 0) {
							item.commitAnswer = item.paperSubjectOptions.findIndex((arr) => arr
								.hasSelectThisOption)
							item.rightAnswer = item.paperSubjectOptions.findIndex((arr) => arr.trueOrFalse)
						} else {
							var commitAnswer = []
							var rightAnswer = []
							item.paperSubjectOptions.forEach((aa, sort) => {
								if (aa.hasSelectThisOption) {
									commitAnswer.push(sort)
								}
								if (aa.trueOrFalse) {
									rightAnswer.push(sort)
								}
							})
							item.commitAnswer = commitAnswer;
							item.rightAnswer = rightAnswer;
						}
					})
					this.$refs['my-modal'].show()
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box-card {
		position: relative;

		.retake {
			position: absolute;
			top: 0;
			right: 0;
			background-color: #37D16D;
			color: #fff;
			font-size: 12px;
			padding: 2px 7px;
			border-radius: 0 0 0 10px;
		}
	}

	.time {
		font-size: 13px;
		color: #999;
	}

	.bottom-clearfix {
		margin-top: 8px;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}

	.single-item {
		cursor: pointer;
	}

	.paper-area::-webkit-scrollbar {
		width: 5px;
		height: 10%
	}

	.paper-area::-webkit-scrollbar-track {
		background-color: #f1f1f1;
		border-radius: 10px;

	}

	/* 滚动条的滑轨背景颜色 */
	.paper-area::-webkit-scrollbar-thumb {
		background-color: #A4A9C1;
		border-radius: 10px;
	}

	@media screen and (max-width: 997px) {
		.paper-area {
			max-height: 500px !important;
		}

		.paper-area::-webkit-scrollbar {
			width: 0px !important;
			height: 10%
		}

	}

	.paper-area {
		background-color: #FFF;
		padding: 0 15px;
		max-height: 700px;
		overflow-y: scroll;

		.paper-title {
			text-align: center;
			font-weight: 600;
			font-size: 17px;
			margin-bottom: 20px;
		}

		.paper-split {
			width: 100%;
			height: 5px;
			background-color: #53A4F4;
			margin: 15px 0;
		}

		.question-area {
			margin-bottom: 25px;

			.subject-name {
				margin-bottom: 10px;
			}

			.option-item {
				margin-left: 10px;
				margin-bottom: 10px;
			}
		}
	}

	.pop-top {
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.pass {
			width: 80px;
			height: 80px;
		}

		.score {
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #FA8936;
		}
	}
</style>